import { ReduxHelper } from "@al/base-lib";

import urls, { request } from "../urls";

export default ReduxHelper.combine({
  // 商详—图文详情
  asyncGetProductDescription: request(urls.getProductDesc),
  // 商详-sku价格
  asyncGetProductSkuInfos: request(urls.getProductSkuInfos),
  // 商详—重构商品相似推荐
  asyncGetSimilarProduct: request(urls.getSimilarProduct),
  // 商详—评价列表
  asyncGetDetailEvaluate: request(urls.getDetailEvaluate),
  // 商详—优惠券列表
  asyncGetProductCoupons: request(urls.getProductCoupons),
  // 商详—平台保障信息
  asyncGetPlatformGuarantee: request(urls.getPlatformGuarantee),
  // 商详—手动领取优惠券
  asyncGetCoupon: request(urls.getCoupon),
  // 商详—批量领券优惠券(自动领券)
  asyncGetCouponAuto: request(urls.getCouponAuto),
  // 商详—运费
  asyncGetFreight: request(urls.getFreight),
  // 商详—订单信息统计，销量
  asyncGetSpuSales: request(urls.getSpuSales),
  // 商详-分享ActionKey接口
  asyncGetShareParams: request(urls.getShareParams),
  // 商详 - 获取分期
  asyncGetInstallmentPlants: request(urls.getInstallmentPlants),
  asyncMakeDeepLink: request(urls.getDeeplink),
  // 商详—店铺信息
  asyncGetShopInfo: request(urls.getShopInfo),
  // 获取广告信息
  asyncAdGroupInfo: request(urls.getAdGroupInfo),
});
